import { apiClient } from './api'

export interface Department {
  id: number
  name: string
  description?: string
  head_id?: number
  organization_id?: number
  created_at: string
  updated_at: string
}

export interface DepartmentCreate {
  name: string
  description?: string
  head_id?: number
}

export interface DepartmentUpdate {
  name?: string
  description?: string
  head_id?: number
}

export const departmentsService = {
  async list(): Promise<Department[]> {
    const response = await apiClient.get('/api/v1/departments/')
    return response.data
  },

  async get(id: number): Promise<Department> {
    const response = await apiClient.get(`/api/v1/departments/${id}`)
    return response.data
  },

  async create(data: DepartmentCreate): Promise<Department> {
    const response = await apiClient.post('/api/v1/departments/', data)
    return response.data
  },

  async update(id: number, data: DepartmentUpdate): Promise<Department> {
    const response = await apiClient.put(`/api/v1/departments/${id}`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v1/departments/${id}`)
  },
}
